/**
 * Confirm dismiss of a completed bulk report (markViewed).
 */
import { observer } from "mobx-react";
import { ConfirmModal } from "../../../../../components/modal/components/confirm-modal/confirm-modal";
import { BUTTON_VARIANTS } from "../../../../../components/inputs/button-variants";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";

interface IProps {
    isLoading: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

const RmaListBulkDismissModal: React.FC<IProps> = observer(({ isLoading, onCancel, onConfirm }) => {
    const { getTranslation } = useDashboardTranslation();
    const scope = "dashboard-returns-page";

    return (
        <ConfirmModal
            title={getTranslation("BULK_DISMISS_CONFIRM_TITLE", scope)}
            text={getTranslation("BULK_DISMISS_CONFIRM_BODY", scope)}
            cancelButton={{
                title: getTranslation("BULK_DISMISS_CONFIRM_CANCEL", scope),
                onClick: onCancel,
                disabled: isLoading,
            }}
            okButton={{
                title: getTranslation("BULK_DISMISS_CONFIRM_OK", scope),
                onClick: onConfirm,
                disabled: isLoading,
                hasLoader: true,
                isLoading,
                variant: BUTTON_VARIANTS.Primary,
            }}
        />
    );
});

export default RmaListBulkDismissModal;
